var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglepodcast(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    "data-name": "Layer 1",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffba00",
    d: "M16,29a1.5,1.5,0,0,1-1.5-1.5v-2a1.5,1.5,0,0,1,3,0v2A1.5,1.5,0,0,1,16,29Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0066da",
    d: "M4.5,18.5A1.5,1.5,0,0,1,3,17V15a1.5,1.5,0,0,1,3,0v2A1.5,1.5,0,0,1,4.5,18.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M27.5,18.5A1.5,1.5,0,0,1,26,17V15a1.5,1.5,0,0,1,3,0v2A1.5,1.5,0,0,1,27.5,18.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffba00",
    d: "M16,8a1.5,1.5,0,0,1-1.5-1.5v-2a1.5,1.5,0,0,1,3,0v2A1.5,1.5,0,0,1,16,8Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea4435",
    d: "M10.25 24.5A1.5 1.5 0 0 1 8.75 23V21a1.5 1.5 0 0 1 3 0v2A1.5 1.5 0 0 1 10.25 24.5zM10.25 17a1.5 1.5 0 0 1-1.5-1.5v-6a1.5 1.5 0 0 1 3 0v6A1.5 1.5 0 0 1 10.25 17z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffba00",
    d: "M16,22a1.5,1.5,0,0,1-1.5-1.5v-9a1.5,1.5,0,0,1,3,0v9A1.5,1.5,0,0,1,16,22Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#00ac47",
    d: "M21.75 12.75a1.5 1.5 0 0 1-1.5-1.5v-2a1.5 1.5 0 0 1 3 0v2A1.5 1.5 0 0 1 21.75 12.75zM21.75 24.25a1.5 1.5 0 0 1-1.5-1.5v-6a1.5 1.5 0 0 1 3 0v6A1.5 1.5 0 0 1 21.75 24.25z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglepodcast);
export default __webpack_public_path__ + "static/media/googlepodcast.70e7f0c2cf152c92ff5c28f548d3fd1a.svg";
export { ForwardRef as ReactComponent };